const getters = {
  localization: state => state.user.usercontent.localization,
  firstRoute: state => state.app.firstRoute,
}
export default getters
